import { render, staticRenderFns } from "./EmployeeTraining.vue?vue&type=template&id=534c5370"
import script from "./EmployeeTraining.vue?vue&type=script&lang=js"
export * from "./EmployeeTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports